<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="List" name="List">

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="5">
            <div class="grid-content bg-purple-light">
              <el-tooltip
                class="item"
                effect="light"
                :content="`Search Table`"
                placement="top">
                <fg-input
                  class="input-sm"
                  placeholder="Search"
                  v-model="searchQuery"
                  addon-right-icon="nc-icon nc-zoom-split"
                ></fg-input>
              </el-tooltip>
            </div>
        </el-col>
        </el-row>

        <div class="row">
          <div class="col-sm-12 mt-2">
            <el-table
              v-loading="isTableLoading"
              class="table-striped"
              :data="queriedData"
              border
              highlight-current-row
              style="width: 100%">
              <el-table-column
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :class-name="column.className"
              ></el-table-column>
              <el-table-column
                :fixed="false"
                class-name="td-actions text-center"
                label="#"
              >
                <template slot-scope="props">
                  <p-button
                    type="warning"
                    size="sm"
                    icon
                    @click="$router.push(`/customers/${props.row.id}`)"
                  >
                    <i class="el-icon-edit"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Create" name="Create">
        <FormCreate></FormCreate>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import Vue from "vue"
import * as _apiCustomer from "@/api/customer"
import FormCreate from "@/components/Dashboard/Views/Customers/FormCreate"
import { mapGetters } from 'vuex'
import { Card } from
"src/components/UIComponents"
import {
  Table,
  TableColumn,
  Select,
  Option,
  Tabs,
  TabPane,
  Button,
  Tooltip,
  Form,
  FormItem,
  Input,
  Checkbox,
  Notification,
  DatePicker,
  Tag,
  Scrollbar,
  Row,
  Col,
} from "element-ui"
import PPagination from "src/components/UIComponents/Pagination.vue"
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Tag)
Vue.use(Scrollbar)
Vue.use(Row)
Vue.use(Col)

export default {
  components: {
    PPagination,
    Card,
    Notification,
    FormCreate,
  },
  data() {
    return {
      arrivalsDate: [],
      pickerOptions1: {
        disabledDate: this.disabledDueDate,
      },
      shipmentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10),
      fileterImage: false,
      isRefreshLoading: false,
      gcsURL: 'https://storage.googleapis.com/e-express-upload/damage/',
      isTableLoading: false,
      modalsEdit: {
        notice: false,
        header: '',
        content: {},
      },
      modals: {
        notice: false,
        header: '',
        content: {},
      },
      activeName: "List",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["thName", "enName", "thFullName", "enFullName", "address"],
      tableColumns: [
        {
          prop: "thName",
          label: "TH Name",
          minWidth: 150,
          fixed: false,
          className:""
        },
        {
          prop: "enName",
          label: "EN Name",
          minWidth: 160,
          fixed: false,
          className:""
        },
        {
          prop: "thFullName",
          label: "TH Full Name",
          minWidth: 140,
          fixed: false,
          className:""
        },
        {
          prop: "enFullName",
          label: "EN Full Name",
          minWidth: 120,
          fixed: false,
          className:"text-center"
        },
        {
          prop: "address",
          label: "Address",
          minWidth: 200,
          fixed: false,
          className:"text-center"
        },
      ],
      tableData: [],
      selects: {
        simple: "",
        list: [],
      },
      modalLoggingScan: {
        header: '',
        notice: false,
        data: []
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "$_user/currentUser",
      getSelected: "$_mawb/getSelected"
    }),
    pagedData() {
      return this.tableData.slice(this.from, this.to)
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      let result
  // this.tableData= [

  //       {
  //         thName: 'x',
  //         enName: 'z',
  //         thFullName: 'asdf',
  //         enFullName: 'asd',
  //         address: 'xcvxcv',
  //       }
  // ]
      console.log(this.tableData)

      if (!this.searchQuery && !this.fileterImage) { // false, false
        this.pagination.total = this.tableData.length
        return this.pagedData
      } else if (this.searchQuery && this.fileterImage) { // true, true
        let filtered = this.tableData.filter(row => {
          let isIncluded = false
          for (let key of this.propsToSearch) {
            let rowValue = row[key].toLocaleLowerCase().toString()
            if (rowValue.includes && rowValue.includes(this.searchQuery.toLocaleLowerCase())) {
              isIncluded = true
            }
          }
          return isIncluded
        })

        result = filtered.filter(row => {
          let isIncluded = false
          if (this.fileterImage && row['images']) {
            isIncluded = true
          }
          return isIncluded
        })

      } else if (this.searchQuery && !this.fileterImage) { // true, false
        result = this.tableData.filter(row => {
          let isIncluded = false
          for (let key of this.propsToSearch) {
              let rowValue = row[key].toLocaleLowerCase().toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLocaleLowerCase())) {
                isIncluded = true
              }
          }
          return isIncluded
        })
      } else if (!this.searchQuery && this.fileterImage) { // false, true
        result = this.tableData.filter(row => {
          let isIncluded = false
          for (let key of this.propsToSearch) {
            if (this.fileterImage && row['images']) {
              isIncluded = true
            }
          }
          return isIncluded
        })
      }
      this.pagination.total = result.length
      return result.slice(this.from, this.to)
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total() {
      this.pagination.total = this.tableData.length
      return this.tableData.length
    },
    selected() {
      return this.selects.simple
    }
  },
  watch: {
  },
  created () {
    this.activeName = this.$route.query.tab || 'List'
    this.getAllCustomer()
  },
  mounted () {
  },
  methods: {
    getAllCustomer(){
      _apiCustomer.getAll()
      .then(response => {
        this.tableData = response.data
      })
      .catch(error => {
        this.$notify({
          message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      });
    },
    getMAWBByDate (date) {
      _apiMawb.getByDate(date)
      .then(res => {
        this.selects.list = res.data
      })
      .catch(error => {
        this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      })
      .finally(() => {
        this.isRefreshLoading = false
      })
    },
    getParcelAllByMAWBID (v) {
      this.isRefreshLoading = true
      this.isTableLoading = true
      let _tableData = this.tableData
      let _selects = this.selects
      _apiParcel.getAllByMawbID(v)
      .then(response => {
        try {
          _tableData = response.data
        }
        catch(err) {
          console.log(err)
        }
      })
      .catch(error => {
        this.$notify({
          message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      })
      .finally(() => {
        this.selects = _selects
        this.tableData = _tableData
        this.isRefreshLoading = false
        this.isTableLoading = false
      })
    },
    refresh () {
      // this.getArrivalsDate()
      // if (this.selected) {
      //   this.getMAWBByDate(this.formatDate(this.shipmentDate))
      //   this.getParcelAllByMAWBID(this.selected)
      // } else if (this.shipmentDate) {
      //     this.initialData(this.shipmentDate, '')
      // }
    },
    handleClick(tab, event) {
      // this.$router.push({query: {tab: tab.name}})
    },
    handleEdit(index, row, ref) {
      // this.modalsEdit.header = row.hawb.toString() || "-"
      // this.modalsEdit.notice = true
      // this.modalsEdit.content = row
    },
    handleDelete(index, row) {
      // let indexToDelete = this.tableData.findIndex(
      //   tableRow => tableRow.id === row.id
      // )
      // if (indexToDelete >= 0) {
      //   this.tableData.splice(indexToDelete, 1)
      // }
    },
    handleShow(index, row, ref) {
      // this.modals.content = Object.assign({}, row)
      // this.modals.header = row.hawb.toString() || "-"
      // this.modals.notice = true
    },
    csvExport() {
      try {
        let arrData = [...this.tableData]
        arrData.forEach(function(v){
          delete v.id
          delete v.historyInternalStatus
          delete v.images
          delete v.customerID
          delete v.updatedAt
        })
        var csv = "\ufeff" + this.$papaparse.unparse(arrData);

        var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
        var csvURL =  null;
        if (navigator.msSaveBlob)
        {
            csvURL = navigator.msSaveBlob(csvData, 'download.csv');
        }
        else
        {
            csvURL = window.URL.createObjectURL(csvData);
        }

        var link = document.createElement('a');
        link.href = csvURL;

        link.setAttribute("download", this.selected + "_" + new Date().toJSON().slice(0,10).replace(/-/g,'') + ".csv")
        link.click()

      } catch (err) {
        console.log(err)
      }
    },
    showViewer (hawb) {
      this.$refs['viewer-'+hawb].$viewer.show()
    },
    getGCSURL (hawb, imageName) {
      return this.gcsURL + hawb + '/' + imageName
    },
    clickNew() {
      this.activeName = 'new'
      this.$router.push({query: {tab: 'new'}})
    },
    onCheckboxChange () {
      this.fileterImage = !this.fileterImage
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [day, month, year].join('-')
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-action {
  display: inline-block;
  padding: 0px 8px;
  cursor: pointer;
  &:hover {
    color: #5981ee !important;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }
}

.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
// .pull-right:nth-child(2) {
  // padding-right: 20px;
  // background: red;
// }
.el-form-item {
    margin-bottom: 0px;
}
.viewer {
  display: none;
}
.checkBox {
  display: inline-block;
  @media screen and (max-width: 1024px) {
    margin: auto;
  }
}
.custom-datepicket {
  width: 100%;
  margin-right: 10px;
}

  // .el-col {
  //   border-radius: 4px;
  // }
  // .bg-purple-dark {
  //   background: #99a9bf;
  // }
  // .bg-purple {
  //   background: #d3dce6;
  // }
  // .bg-purple-light {
  //   background: #e5e9f2;
  // }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;

    @media screen and (max-width: 1024px) {
      padding: 5px 0px;
    }
  }
</style>
